import ActionType from 'actions/ActionType'

export default (state = { filter: null, setByData: false }, action) => {
  switch (action.type) {
    case ActionType.Auth.CURRENT_SESSION_SUCCESS:
      return {
        ...state,
        filter: action.payload?.idToken?.payload?.['cognito:username'],
      }
    case ActionType.Data.READ_SUCCESS:
      // logic for if the read is from 'inboxuserfilter'
      // if (
      //   action?.entityType === 'account/ap/status' &&
      //   action?.payload?.enabled === false &&
      //   !state.setByData
      // ) {
      //   return { ...state, filter: 'all' }
      // }

      if (
        action?.entityType === 'inboxuserfilter' &&
        action?.payload?.preference
      ) {
        return {
          filter: action.payload.preference || state.filter,
          setByData: Boolean(action.payload.preference),
        }
      }

      return state
    // case ActionType.Data.LIST_SUCCESS:
    //   if (action?.entityType === 'inboxuserfilter' && action?.payload?.length) {
    //     return {
    //       filter: action.payload?.[0]?.preference || state.filter,
    //       setByData: true,
    //     }
    //   }
    //   return state
    case ActionType.Data.CREATE_SUCCESS:
      if (action?.entityType === 'inboxuserfilter') {
        return { ...state, filter: action.payload.preference, setByData: true }
      }
      return state
    // case ActionType.Inbox.FILTER_USER_CONVERSATIONS_LIST:
    //   return { ...state, filter: action.payload }
    default:
      return state
  }
}
